import { MDSText, MDSTextColor, MDSTextVariant, MDSTextWeight } from "@/mds/components/text";
import { getSlots } from "@/mds/utils/slots";
import { StyledPlanCardPrice } from "./plan-card-price.style";
import { MDSPlanCardSlot } from "../plan-card.types";

export const MDSPlanCardPrice = ({
  children,
  priceVariant = MDSTextVariant.HeaderL,
  priceTermVariant = MDSTextVariant.TextXs,
}: React.PropsWithChildren & {
  priceVariant?: MDSTextVariant;
  priceTermVariant?: MDSTextVariant;
}) => {
  const price = getSlots(children, MDSPlanCardSlot.Price);
  const priceTerm = getSlots(children, MDSPlanCardSlot.PriceTerm);
  const priceBadge = getSlots(children, MDSPlanCardSlot.TitleBadge);
  return (
    <StyledPlanCardPrice>
      <MDSText variant={priceVariant} color={MDSTextColor.Contrast}>
        {price}
      </MDSText>
      <MDSText variant={priceTermVariant} weight={MDSTextWeight.Medium}>
        {priceTerm}
      </MDSText>
      {priceBadge}
    </StyledPlanCardPrice>
  );
};

export const PlanCardPriceTerm = (props: React.PropsWithChildren) => (
  <MDSText variant={MDSTextVariant.TextS} weight={MDSTextWeight.Medium} {...props} />
);
